import { render, staticRenderFns } from "./SellDomain.vue?vue&type=template&id=1b69c926&"
import script from "./SellDomain.vue?vue&type=script&lang=js&"
export * from "./SellDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SellDomain.vue"
export default component.exports